/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import { message } from 'antd';
import PropTypes from 'prop-types';
import initFaskClick from 'react-fastclick';

initFaskClick();

const ContextType = {
  // Enables critical path CSS rendering
  // https://github.com/kriasoft/isomorphic-style-loader
  insertCss: PropTypes.func.isRequired,
  pathname: PropTypes.string.isRequired,
  query: PropTypes.object,
};

/**
 * The top-level React component setting context (global) variables
 * that can be accessed from all the child components.
 *
 * https://facebook.github.io/react/docs/context.html
 *
 * Usage example:
 *
 *   const context = {
 *     history: createBrowserHistory(),
 *     store: createStore(),
 *   };
 *
 *   ReactDOM.render(
 *     <App context={context}>
 *       <Layout>
 *         <LandingPage />
 *       </Layout>
 *     </App>,
 *     container,
 *   );
 */
class App extends React.PureComponent {
  static propTypes = {
    context: PropTypes.shape(ContextType).isRequired,
    children: PropTypes.element.isRequired,
  };

  static childContextTypes = ContextType;

  getChildContext() {
    return this.props.context;
  }

  componentDidMount() {
    const theUA = window.navigator.userAgent.toLowerCase();
    if (
      (theUA.match(/msie\s\d+/) && theUA.match(/msie\s\d+/)[0]) ||
      (theUA.match(/trident\s?\d+/) && theUA.match(/trident\s?\d+/)[0])
    ) {
      const ieVersion =
        theUA.match(/msie\s\d+/)[0].match(/\d+/)[0] ||
        theUA.match(/trident\s?\d+/)[0];
      if (ieVersion <= 9) {
        message.warning(
          <div>
            系统检测到浏览器版本过低，为了得到良好的体验效果，请下载
            <a target="_blank" href="https://www.google.cn/chrome/">
              chrome
            </a>{' '}
            等高级浏览器
          </div>,
          99999,
        );
      }
    }
  }

  render() {
    // NOTE: If you need to add or modify header, footer etc. of the app,
    // please do that inside the Layout component.
    return React.Children.only(this.props.children);
  }
}

export default App;
